const VARIANTS = {
  success: "border-hc-success/35 bg-hc-success-muted text-hc-success",
  warning: "border-hc-warning/35 bg-hc-warning-muted text-hc-warning",
  primary: "border-hc-primary/35 bg-hc-primary/10 text-hc-primary",
  neutral: "border-hc-surface-border bg-white/5 text-hc-text-dim",
  muted: "border-hc-surface-border-strong bg-hc-surface text-hc-text-muted",
};

const SIZES = {
  sm: "px-1.5 py-0.5 text-[10px]",
  md: "px-2 py-0.5 text-xs",
};

export default function StatusPill({
  variant = "neutral",
  size = "md",
  className = "",
  children,
}) {
  return (
    <span
      className={`rounded-full border font-medium ${VARIANTS[variant] ?? VARIANTS.neutral} ${SIZES[size] ?? SIZES.md} ${className}`}
    >
      {children}
    </span>
  );
}
